module.exports = __webpack_public_path__ + "static/acrylic01-6a30dac982a4fea71894f49adcc667c1.jpg";